<script lang="ts">
	import Formatted from "./common/Formatted.svelte";

	const {
		headline,
		description,
		highlightedDescription,
	}: { headline: string; description?: string; highlightedDescription?: string } = $props();
</script>

<section class="bg-black full-width grid-container pt-20 pb-28">
	<div class="flex flex-col items-center text-center gap-10">
		<h2 class="text-lightblue"><Formatted text={headline} /></h2>
		{#if description ?? highlightedDescription}
			<div class="flex flex-col max-w-3xl">
				{#if description}
					<p class="text-md text-lightwhite leading-8">
						<Formatted text={description} />
					</p>
				{/if}
				{#if highlightedDescription}
					<p class="text-lightblue font-bold text-md leading-8">
						<Formatted text={highlightedDescription} />
					</p>
				{/if}
			</div>
		{/if}
	</div>
</section>
